import { createApiClient } from '@lms/api-client';
import { useNotificationStore } from '../store/notifications';

export const apiBaseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const baseUrl = apiBaseUrl;

export const apiClient = createApiClient({
  baseUrl,
  token: localStorage.getItem('admin_token') || undefined,
  on401: () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('admin_user');
    if (!window.location.pathname.includes('/login')) {
      window.location.href = '/login';
    }
  },
  onError: error => {
    useNotificationStore.getState().addNotification({
      type: 'error',
      title: 'System Error',
      message: error.message,
    });
  },
});

// Update token when it changes in the store
export function updateApiClientToken(token: string | null) {
  apiClient.setToken(token);
}
